import { createAction } from '../../../store.model';
import { User } from '../../../user/user.model';
import { MainConfig, SearchParams } from '../../core';
import { ActionType } from '../landing.action';
import { GridType } from '../model/grid-type.model';
import { ReloadSearchRet } from '../model/reload-search-ret.model';

export interface Reload {
    user?: User;
    searchOpts?: Array<{
        type: GridType;
        params: SearchParams;
    }>;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.EVAL_LANDING__RELOAD,
);

export interface ReloadResult extends Reload {
    config?: MainConfig;
    searchRets?: ReloadSearchRet[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.EVAL_LANDING__RELOAD_RESULT,
);
